// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DemoPlayer_container__gLG6N {
    margin-bottom: 70px;
    padding-top: 60px;
}

.DemoPlayer_container__gLG6N h2 {
    text-align: center;
    font-size: 46px;
}

.DemoPlayer_container__gLG6N > p {
    text-align: center;
    font-size: 24px;
    padding: 30px 5% 70px ;
}

.DemoPlayer_player-text-cont__-Fv-H {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
}

.DemoPlayer_container-audio-data__UwMgn {
    justify-self: center;
    align-self: center;
    width: 90%;
}

.DemoPlayer_audio-transcription__wtXqB,
.DemoPlayer_audio-data-complement__anvPy {
    padding: 15px;
    font-family: "Tenorite", sans-serif;
    border-radius: 15px;
    box-shadow: 0 8px 24px rgba(28, 35, 43, 0.25);
}

.DemoPlayer_audio-transcription__wtXqB {
    font-size: 20px !important;
}

.DemoPlayer_audio-data-complement__anvPy {
    margin-top: 25px;
}

.DemoPlayer_audio-data-complement__anvPy p {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 2px;
    font-weight: 700;
    font-size: 22px;
}

.DemoPlayer_audio-data-complement__anvPy p span {
    font-weight: 400;
    font-size: 20px;
}

.DemoPlayer_msg-demo__Eg\\+cl {
    display: block !important;
    margin-top: 25px;
    text-align: center;
    font-weight: 400 !important;
}

.DemoPlayer_msg-demo__Eg\\+cl a {
    text-decoration: underline;
    cursor: pointer;
}


@media screen and (max-width: 1536px) {
    .DemoPlayer_container__gLG6N h2 {
        font-size: 40px;
    }

    .DemoPlayer_container__gLG6N > p {
        font-size: 22px;
    }

    .DemoPlayer_audio-transcription__wtXqB {
        font-size: 18px;
    }

    .DemoPlayer_audio-data-complement__anvPy p {
        font-size: 20px;
    }

    .DemoPlayer_audio-data-complement__anvPy p span {
        font-size: 18px;
    }
}

@media screen and (max-width: 1200px) {
    .DemoPlayer_container__gLG6N h2 {
        font-size: 36px;
    }

    .DemoPlayer_container__gLG6N > p {
        font-size: 20px;
    }

    .DemoPlayer_container-audio-data__UwMgn {
        width: 95%;
    }
}

@media screen and (max-width: 992px) {
    .DemoPlayer_container__gLG6N > p {
        font-size: 18px;
    }

    .DemoPlayer_audio-transcription__wtXqB {
        font-size: 16px;
    }

    .DemoPlayer_audio-data-complement__anvPy p {
        font-size: 18px;
    }

    .DemoPlayer_audio-data-complement__anvPy p span {
        font-size: 16px;
    }
}

@media screen and (max-width: 768px) {
    .DemoPlayer_container__gLG6N h2 {
        font-size: 34px;
    }

    .DemoPlayer_player-text-cont__-Fv-H {
        grid-template-columns: none;
    }

    .DemoPlayer_container-audio-data__UwMgn {
        margin-top: 35px;
    }
}

@media screen and (max-width: 576px) {
    .DemoPlayer_container__gLG6N h2 {
        font-size: 30px;
    }

    .DemoPlayer_container__gLG6N > p {
        font-size: 16px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/BodyLanding/DemoPlayer/DemoPlayer.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;AACd;;AAEA;;IAEI,aAAa;IACb,mCAAmC;IACnC,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,eAAe;AACnB;;;AAGA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".container {\n    margin-bottom: 70px;\n    padding-top: 60px;\n}\n\n.container h2 {\n    text-align: center;\n    font-size: 46px;\n}\n\n.container > p {\n    text-align: center;\n    font-size: 24px;\n    padding: 30px 5% 70px ;\n}\n\n.player-text-cont {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n}\n\n.container-audio-data {\n    justify-self: center;\n    align-self: center;\n    width: 90%;\n}\n\n.audio-transcription,\n.audio-data-complement {\n    padding: 15px;\n    font-family: \"Tenorite\", sans-serif;\n    border-radius: 15px;\n    box-shadow: 0 8px 24px rgba(28, 35, 43, 0.25);\n}\n\n.audio-transcription {\n    font-size: 20px !important;\n}\n\n.audio-data-complement {\n    margin-top: 25px;\n}\n\n.audio-data-complement p {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 2px;\n    font-weight: 700;\n    font-size: 22px;\n}\n\n.audio-data-complement p span {\n    font-weight: 400;\n    font-size: 20px;\n}\n\n.msg-demo {\n    display: block !important;\n    margin-top: 25px;\n    text-align: center;\n    font-weight: 400 !important;\n}\n\n.msg-demo a {\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n\n@media screen and (max-width: 1536px) {\n    .container h2 {\n        font-size: 40px;\n    }\n\n    .container > p {\n        font-size: 22px;\n    }\n\n    .audio-transcription {\n        font-size: 18px;\n    }\n\n    .audio-data-complement p {\n        font-size: 20px;\n    }\n\n    .audio-data-complement p span {\n        font-size: 18px;\n    }\n}\n\n@media screen and (max-width: 1200px) {\n    .container h2 {\n        font-size: 36px;\n    }\n\n    .container > p {\n        font-size: 20px;\n    }\n\n    .container-audio-data {\n        width: 95%;\n    }\n}\n\n@media screen and (max-width: 992px) {\n    .container > p {\n        font-size: 18px;\n    }\n\n    .audio-transcription {\n        font-size: 16px;\n    }\n\n    .audio-data-complement p {\n        font-size: 18px;\n    }\n\n    .audio-data-complement p span {\n        font-size: 16px;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .container h2 {\n        font-size: 34px;\n    }\n\n    .player-text-cont {\n        grid-template-columns: none;\n    }\n\n    .container-audio-data {\n        margin-top: 35px;\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .container h2 {\n        font-size: 30px;\n    }\n\n    .container > p {\n        font-size: 16px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DemoPlayer_container__gLG6N`,
	"player-text-cont": `DemoPlayer_player-text-cont__-Fv-H`,
	"container-audio-data": `DemoPlayer_container-audio-data__UwMgn`,
	"audio-transcription": `DemoPlayer_audio-transcription__wtXqB`,
	"audio-data-complement": `DemoPlayer_audio-data-complement__anvPy`,
	"msg-demo": `DemoPlayer_msg-demo__Eg+cl`
};
export default ___CSS_LOADER_EXPORT___;
